<template>
    <div>
        <tit data-aos="fade-up" class="tit--lg white--text">
            <span class="primary--text">당신의 새로운 시작에 함께 하겠습니다. </span>
        </tit>
        <span data-aos="fade-up" data-aos-delay="100" class="line my-12px my-md-24px"></span>
        <txt data-aos="fade-up" data-aos-delay="200" class="white--text line-height-17">
            <p class="mb-12px mb-md-24px">안녕하세요. 이혼전문변호사 문종하입니다.</p>
            <p>언제나 의뢰인의 이야기에 귀를 기울이고 전문적인 도움을 드리겠습니다. 이혼소송은 각자의 상황에 맞는 해결책이 필요한 만큼 의뢰인의 상황에 적합한 최상의 결과를 만들어 드리겠습니다. 어렵고 힘든 시간을 지나 새로운 시작에 힘이 되어 드리겠습니다.</p>
        </txt>
    </div>
</template>

<script>
import tit from '@/components/publish/styles/typography/tit.vue'
import Txt from '@/components/publish/styles/typography/txt.vue'

export default {
    components: { tit, Txt },
    
}
</script>